export const TIMELINE_ELEMENT_ID = "timeline";
export const TIMELINE_CONTROLS_ELEMENT_ID = "timeline-controls";
export const GUTTER_SIZE = 3;
export const TRACK_CLASSNAME = "track";
export const CLIP_CLASSNAME = "clip";
export const TIMELINE_TRACKS_CONTAINER_ID = "timeline-tracks-container";
